import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { LoanParams } from 'app/models/loan-params'
import { loadOneLoan } from 'app/state/ducks/loans/thunks'
import { ErrorNotification } from 'app/views/components/notifications/notification'

/**
 * Resolves the approved loan a row-action modal edits, by id from the
 * backend, every time. Never from the approved-loans slice: the Servicing
 * page does not reload it, and an increase or payment approved since it was
 * read leaves a loan there with its old principal — a rollover, conversion,
 * merge or payment form would calculate from that. One small request per
 * open is the price of a current amount. Returns undefined, after a
 * notification, when the loan cannot be loaded.
 */
export function useApprovedLoan() {
  const dispatch = useDispatch()

  return useCallback(
    async (loanId: string | undefined): Promise<LoanParams | undefined> => {
      if (!loanId) return undefined
      // the thunk answers { success: false } on a 4xx but THROWS on a request
      // with no response (network, timeout): both end here as "not loaded"
      let loan: any
      try {
        const loaded: any = await dispatch(loadOneLoan(loanId, 'Approved'))
        loan = loaded?.payload
      } catch {
        loan = undefined
      }
      if (loan && typeof loan === 'object' && loan.id) return loan as LoanParams
      ErrorNotification({
        title: 'Loan not found',
        message: `Loan ${loanId} could not be loaded`,
      })
      return undefined
    },
    [dispatch],
  )
}
